import { useCallback, useState } from 'react';

import { useAppDispatch } from '../hooks';
import { fetchExtensionDownloadUrl } from '../reducers/general';

export const useExtensionDownload = (): {
    downloadExtension: () => Promise<void>;
    isLoading: boolean;
} => {
    const dispatch = useAppDispatch();
    const [ isLoading, setIsLoading ] = useState(false);

    const downloadExtension = useCallback(async () => {
        if (isLoading) {
            return;
        }
        
        setIsLoading(true);
        try {
            const downloadUrl = await dispatch(fetchExtensionDownloadUrl()).unwrap();
            if (downloadUrl) {
                window.open(downloadUrl, '_blank');
            }
        } catch (error) {
            console.error('Failed to get extension download URL:', error);
        } finally {
            setIsLoading(false);
        }
    }, [ dispatch, isLoading ]);

    return { downloadExtension, isLoading };
};

